module.exports = __webpack_public_path__ + "img/ylsz.3033f5fe.png";